import React, { useEffect } from 'react';
import data from '../data/GetnetSEP.json';
import WelcomeSEP from '../components/WelcomeSEP';
import VideoSection from '../components/VideoSection';
import IntegrationSEP from '../components/IntegrationSEP';
import ApiFunctionalities from '../components/ApiFunctionalities';
import RegionalConnections from '../components/RegionalConnections';
import SepFooter from '../components/SepFooter';
const GetnetSEP = () => {
    const paymentData = data.find((item) => item.id === "getnetsep");

    useEffect(() => {
        if (paymentData) {
            document.title = `Getnet SEP | Getnet`;
        } else {
            document.title = "Página no encontrada";
        }
    }, [paymentData]);

    if (!paymentData) {
        return <p>Datos no encontrados</p>;
    }

    if (!paymentData) {
        return <p>Datos no encontrados</p>;
    }

    return (
        <div>
            <WelcomeSEP data={paymentData.welcome[0]} />
            <VideoSection data={paymentData.videoSectionSEP[0]} />
            <IntegrationSEP data={paymentData.integration[0]} />
            <ApiFunctionalities data={paymentData.apiFunctionalities[0]} />
            <RegionalConnections data={paymentData.regionalConnections[0]} />
            <SepFooter data={paymentData.sepFooter[0]} />
        </div>
    );
};

export default GetnetSEP;
